import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { Fab, Action } from 'react-tiny-fab';
import { FaHeadset } from "react-icons/fa";
import 'react-tiny-fab/dist/styles.css';
import { click } from '@testing-library/user-event/dist/click'
import IphoneMenu from './IphoneMenu';
import DeviceDetectorComponent from './DeviceDetectorComponent';


class Header extends Component {

    state = {
        username: '',
        password: '',
        type: '',
        info: '',
        load: false,
        showMsg: false,
        device: "unknown"
    }

        componentDidMount() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            this.setState({ device: "Android" });
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            this.setState({ device: "iOS" });
        } else {
            this.setState({ device: "Other (e.g., Desktop)" });
        }
    }

    render() {
        return (
            <>
                {/* <div class="cs_preloader">
                    <div class="cs_preloader_in">
                        <div class="cs_wave_first">
                            <svg enable-background="new 0 0 300.08 300.08" viewBox="0 0 300.08 300.08" xmlns="http://www.w3.org/2000/svg"><path d="m293.26 184.14h-82.877l-12.692-76.138c-.546-3.287-3.396-5.701-6.718-5.701-.034 0-.061 0-.089 0-3.369.027-6.199 2.523-6.677 5.845l-12.507 87.602-14.874-148.69c-.355-3.43-3.205-6.056-6.643-6.138-.048 0-.096 0-.143 0-3.39 0-6.274 2.489-6.752 5.852l-19.621 137.368h-9.405l-12.221-42.782c-.866-3.028-3.812-5.149-6.8-4.944-3.13.109-5.777 2.332-6.431 5.395l-8.941 42.332h-73.049c-3.771 0-6.82 3.049-6.82 6.82 0 3.778 3.049 6.82 6.82 6.82h78.566c3.219 0 6.002-2.251 6.67-5.408l4.406-20.856 6.09 21.313c.839 2.939 3.526 4.951 6.568 4.951h20.46c3.396 0 6.274-2.489 6.752-5.845l12.508-87.596 14.874 148.683c.355 3.437 3.205 6.056 6.643 6.138h.143c3.39 0 6.274-2.489 6.752-5.845l14.227-99.599 6.397 38.362c.546 3.287 3.396 5.702 6.725 5.702h88.66c3.771 0 6.82-3.049 6.82-6.82-.001-3.772-3.05-6.821-6.821-6.821z"></path></svg>
                        </div>
                        <div class="cs_wave_second">
                            <svg enable-background="new 0 0 300.08 300.08" viewBox="0 0 300.08 300.08" xmlns="http://www.w3.org/2000/svg"><path d="m293.26 184.14h-82.877l-12.692-76.138c-.546-3.287-3.396-5.701-6.718-5.701-.034 0-.061 0-.089 0-3.369.027-6.199 2.523-6.677 5.845l-12.507 87.602-14.874-148.69c-.355-3.43-3.205-6.056-6.643-6.138-.048 0-.096 0-.143 0-3.39 0-6.274 2.489-6.752 5.852l-19.621 137.368h-9.405l-12.221-42.782c-.866-3.028-3.812-5.149-6.8-4.944-3.13.109-5.777 2.332-6.431 5.395l-8.941 42.332h-73.049c-3.771 0-6.82 3.049-6.82 6.82 0 3.778 3.049 6.82 6.82 6.82h78.566c3.219 0 6.002-2.251 6.67-5.408l4.406-20.856 6.09 21.313c.839 2.939 3.526 4.951 6.568 4.951h20.46c3.396 0 6.274-2.489 6.752-5.845l12.508-87.596 14.874 148.683c.355 3.437 3.205 6.056 6.643 6.138h.143c3.39 0 6.274-2.489 6.752-5.845l14.227-99.599 6.397 38.362c.546 3.287 3.396 5.702 6.725 5.702h88.66c3.771 0 6.82-3.049 6.82-6.82-.001-3.772-3.05-6.821-6.821-6.821z"></path></svg>
                        </div>
                    </div>
                </div> */}

                <div class="paginacontainer">
                    <div class="progress-wrap">
                        <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                        </svg>
                    </div>
                </div>

                <header class={window.location.pathname === '/' ? 'homepage6-body' : 'homepage4-body'}  >
                    {/* var variable = (condition) ? (true block) : ((condition2) ? (true block2) : (else block2)) */}
                    <div id="vl-header-sticky" class="vl-header-area vl-transparent-header">
                        <div class="container">
                            <div class="row align-items-center row-bg1">
                                <div class="col-lg-2 col-md-6 col-6">
                                    <div class="vl-logo">
                                        <Link to="/"><img src="assets/img/logo/rehabLogo.png" alt="" /></Link>
                                    </div>
                                </div>
                                <div class={window.location.pathname === '/' ? 'col-lg-7 d-none d-lg-block' : 'col-lg-5 d-none d-lg-block'}>
                                    <div class="vl-main-menu text-center">
                                        <nav class="vl-mobile-menu-active">
                                            <ul>
                                                <li>
                                                    <Link to="/">Home   </Link>
                                                </li>
                                                <li>
                                                    <Link to="/about-us">Who We Are</Link>
                                                    {/* <a href="about.html">Who We Are   </a> */}

                                                </li>
                                                <li>
                                                    <Link to="/our-services">Services</Link>
                                                    {/* <a href="service.html">Services   </a> */}
                                                </li>

                                                <li><Link to="/gallery">Gallery </Link></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>

                                {
                                    window.location.pathname === '/' ? <>

                                        <div class="col-lg-3 col-md-6 col-6">
                                            <div class="vl-hero-btn d-none d-lg-block text-end">
                                                <div class="btn-area1">
                                                    <a href="tel:+256755260852" target='_blank' class="vl-btn7"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <g clip-path="url(#clip0_5832_90599)">
                                                            <path d="M4.32688 1.17695C4.79912 1.27456 5.1752 1.59185 5.40887 2.01104L6.15321 3.34641C6.42738 3.83825 6.65811 4.25215 6.80878 4.61195C6.96862 4.99364 7.06355 5.37002 7.02016 5.78615C6.97676 6.20229 6.80622 6.55099 6.57107 6.89148C6.3494 7.21245 6.03823 7.56985 5.66848 7.99454L4.57431 9.25135C4.37824 9.4766 4.2802 9.58919 4.27124 9.72994C4.26228 9.87069 4.34263 9.99094 4.50333 10.2314C5.87299 12.2806 7.71894 14.1272 9.76983 15.498C10.0103 15.6587 10.1305 15.739 10.2712 15.7301C10.412 15.7211 10.5247 15.6231 10.7498 15.427L12.0067 14.3328C12.4314 13.963 12.7888 13.6519 13.1098 13.4302C13.4502 13.195 13.799 13.0245 14.2151 12.9811C14.6312 12.9377 15.0077 13.0327 15.3893 13.1925C15.7491 13.3432 16.163 13.5739 16.6547 13.848L17.9902 14.5924C18.4094 14.8261 18.7267 15.2022 18.8243 15.6744C18.9229 16.1515 18.7775 16.6312 18.4562 17.0254C17.2904 18.4557 15.4227 19.3664 13.4633 18.9711C12.259 18.7282 11.0707 18.3234 9.63342 17.4992C6.74558 15.843 4.15636 13.2524 2.50212 10.3679C1.67786 8.9306 1.2731 7.74232 1.03015 6.53794C0.634898 4.57858 1.54559 2.71085 2.9759 1.5451C3.37009 1.22381 3.84971 1.07834 4.32688 1.17695Z" fill="white" />
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3045 1.54C11.432 1.0978 11.894 0.842779 12.3362 0.970388C15.559 1.90041 18.0973 4.43862 19.0275 7.66132C19.155 8.1035 18.9 8.56545 18.4579 8.69304C18.0157 8.8207 17.5537 8.5657 17.4261 8.1235C16.6548 5.45101 14.5466 3.34295 11.874 2.57171C11.4319 2.4441 11.1769 1.98219 11.3045 1.54ZM10.793 5.47187C10.973 5.04825 11.4622 4.85066 11.8859 5.03055C13.2706 5.6186 14.3793 6.72725 14.9673 8.11199C15.1472 8.53562 14.9496 9.02487 14.526 9.20479C14.1024 9.38462 13.6131 9.18704 13.4332 8.76345C13.014 7.77614 12.2217 6.9839 11.2344 6.56463C10.8108 6.38474 10.6132 5.8955 10.793 5.47187Z" fill="white" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_5832_90599">
                                                                <rect width="20" height="20" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg> (0) 755 260852</a>
                                                </div>
                                            </div>

                                            {this.state.device === 'iOS' ? <>

                                                <div class="vl-header-action-item d-block d-lg-none">
                                                    <IphoneMenu />

                                                </div>

                                            </> :
                                                <>

                                                    <div class="vl-header-action-item d-block d-lg-none">
                                                        <button type="button" class="vl-offcanvas-toggle">
                                                            <i class="fa-solid fa-bars-staggered"></i>
                                                        </button>
                                                    </div>

                                                </>
                                            }

                                        </div>

                                    </> : <>

                                        <div class="col-lg-5 col-md-6 col-6">
                                            <div class="vl-hero-btn d-none d-lg-block text-end">
                                                <div class="btn-area1">
                                                    <a href="tel:+256755260852" class="phone"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <g clip-path="url(#clip0_5825_4343)">
                                                            <path d="M4.32688 1.17598C4.79912 1.27359 5.1752 1.59087 5.40887 2.01006L6.15321 3.34544C6.42738 3.83727 6.65811 4.25117 6.80878 4.61098C6.96862 4.99266 7.06355 5.36904 7.02016 5.78518C6.97676 6.20131 6.80622 6.55001 6.57107 6.8905C6.3494 7.21148 6.03823 7.56888 5.66848 7.99356L4.57431 9.25038C4.37824 9.47563 4.2802 9.58821 4.27124 9.72896C4.26228 9.86971 4.34263 9.98996 4.50333 10.2304C5.87299 12.2796 7.71894 14.1262 9.76983 15.497C10.0103 15.6577 10.1305 15.738 10.2712 15.7291C10.412 15.7201 10.5247 15.6221 10.7498 15.426L12.0067 14.3318C12.4314 13.962 12.7888 13.6509 13.1098 13.4292C13.4502 13.194 13.799 13.0235 14.2151 12.9801C14.6312 12.9367 15.0077 13.0317 15.3893 13.1915C15.7491 13.3422 16.163 13.5729 16.6547 13.847L17.9902 14.5915C18.4094 14.8251 18.7267 15.2012 18.8243 15.6734C18.9229 16.1505 18.7775 16.6302 18.4562 17.0244C17.2904 18.4547 15.4227 19.3654 13.4633 18.9701C12.259 18.7272 11.0707 18.3225 9.63342 17.4982C6.74558 15.842 4.15636 13.2514 2.50212 10.367C1.67786 8.92963 1.2731 7.74134 1.03015 6.53696C0.634898 4.5776 1.54559 2.70987 2.9759 1.54412C3.37009 1.22284 3.84971 1.07736 4.32688 1.17598Z" fill="#02015A" />
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3062 1.54C11.4337 1.0978 11.8957 0.842779 12.3379 0.970388C15.5607 1.90041 18.099 4.43862 19.0292 7.66132C19.1567 8.1035 18.9017 8.56545 18.4596 8.69304C18.0174 8.8207 17.5554 8.5657 17.4278 8.1235C16.6565 5.45101 14.5483 3.34295 11.8757 2.57171C11.4336 2.4441 11.1786 1.98219 11.3062 1.54ZM10.7947 5.47187C10.9747 5.04825 11.4639 4.85066 11.8876 5.03055C13.2723 5.6186 14.381 6.72725 14.969 8.11199C15.1489 8.53562 14.9513 9.02487 14.5277 9.20479C14.1041 9.38462 13.6148 9.18704 13.4349 8.76345C13.0157 7.77614 12.2234 6.9839 11.2361 6.56463C10.8125 6.38474 10.6149 5.8955 10.7947 5.47187Z" fill="#02015A" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_5825_4343">
                                                                <rect width="20" height="20" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg> (+256) 755260852</a>
                                                    <a href="https://wa.me/256755260852" class="vl-btn4">WhatsApp<span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                                                    </svg></span></a>
                                                </div>
                                            </div>
                                           
                                                 {this.state.device === 'iOS' ? <>

                                                <div class="vl-header-action-item d-block d-lg-none">
                                                    <IphoneMenu />

                                                </div>

                                            </> :
                                                <>

                                                    <div class="vl-header-action-item d-block d-lg-none">
                                                        <button type="button" class="vl-offcanvas-toggle">
                                                            <i class="fa-solid fa-bars-staggered"></i>
                                                        </button>
                                                    </div>

                                                </>
                                            }

                                        </div>

                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </header>

                {
                    <>
                        {/* <Fab
            
              mainButtonStyles={{ backgroundColor: "#6200ee" }}
              // actionButtonStyles={""}
              // style={{ marginRight: spacing + 'em' }}
              icon={<i class="fa-brands fa-whatsapp f"></i>}
              position={{ bottom: 20, left: 20 }} 
              event={click}
              alwaysShowTitle={true}
              onClick={'https://wa.me/256755260852'}
            >
              <Action text="WhatsApp" onClick={() => alert("Delete clicked")}>

              </Action>

              <Action text="Call" onClick={() => alert("Delete clicked")}>

              </Action>
             
             

            </Fab> */}


                        <div class="paginacontainer">

                            <Fab
                                mainButtonStyles={{ backgroundColor: "#ee3b00ff" }}
                                icon={<FaHeadset style={{ width: '25px', height: '25px' }} />}
                                position="bottom-left"
                                style={{ bottom: "70px", right: "5px" }} // custom offset
                            >
                                <Action text="Chat" onClick={() => window.location.href = "https://wa.me/256755260852"}>
                                    <i class="fa-brands fa-whatsapp f"></i>
                                </Action>

                                <Action text="Call" onClick={() => window.location.href = "tel:+256755260852"}>
                                    <i class="fa-solid fa-phone"></i>
                                </Action>
                            </Fab>

                        </div>

                    </>

                }



            </>
        )
    }
}
export default Header